import { optimalBluePricingApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const OB_CONFIG_ACTION_TYPE = createNamedActions('obConfig', {
  GET_OB_ACCOUNTS: 'GET_OB_ACCOUNTS',
  GET_OB_ACCOUNT_STRATEGY: 'GET_OB_ACCOUNT_STRATEGY',
  GET_CONFIGURATION: 'GET_CONFIGURATION',
  EDIT_CONFIGURATION: 'EDIT_CONFIGURATION',
});

export const getObConfigurationAction = catchAsyncActionError(
  ({ companyId } = {}) =>
    async dispatch => {
      const { data } = await optimalBluePricingApi.getConfiguration({ companyId });

      return dispatch({
        type: OB_CONFIG_ACTION_TYPE.GET_CONFIGURATION,
        payload: data,
      });
    },
);

export const editObConfigurationAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await optimalBluePricingApi.editConfiguration(params);

  return dispatch({
    type: OB_CONFIG_ACTION_TYPE.EDIT_CONFIGURATION,
    payload: data,
  });
});

export const getObAccountsAction = catchAsyncActionError(({ companyId } = {}) => async dispatch => {
  const { data } = await optimalBluePricingApi.getStrategiesAccounts({ companyId });

  return dispatch({
    type: OB_CONFIG_ACTION_TYPE.GET_OB_ACCOUNTS,
    payload: data || [],
  });
});

export const getObAccountStrategyAction = catchAsyncActionError(
  ({ accountId, companyId }) =>
    async dispatch => {
      const { data } = await optimalBluePricingApi.getAccountStrategy({ accountId, companyId });

      return dispatch({
        type: OB_CONFIG_ACTION_TYPE.GET_OB_ACCOUNT_STRATEGY,
        payload: { companyId, accountId: String(accountId), strategy: data },
      });
    },
);
